import { generalCallbacks } from './general';
import { updateSummary } from '../forms/quickorder';
const navigateQuickOrderFormCallback = (callbackData) => {
    updateSummary();
    return generalCallbacks.navigateFormCallback(callbackData);
};
export const quickorderCallbacks = {
    navigateQuickOrderFormCallback,
};
